/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

const withActionHandler = (fn) => {
  if (typeof fn !== 'function') {
    throw new Error(`withActionHandler can only be applied to methods not: ${typeof fn}`);
  }

  return (event, ...args) => {
    if (!event || !event.type || event.type === 'click' || (['keydown', 'keypress'].indexOf(event.type) !== -1 && ['Enter', ' '].indexOf(event.key) !== -1)) {
      fn(event, ...args);
    }
  };
};

export default withActionHandler;
